export const LightGreen = "#e1ece3";
export const Grey = "#e2e2e2";
export const Green = "#028940";
export const DarkGreen = "#008938";
export const Blue = "#0E82AF";
export const Red = "#DE3804";
export const Yellow = "#DE3804";
